import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const CLUSTER_UNSCHEDULED_PODS_QUERY_KEY = 'cluster-unscheduled-pods';

const getUnscheduledPodsQueryKey = (clusterId: string) =>
  [CLUSTER_UNSCHEDULED_PODS_QUERY_KEY, clusterId] as const;

const getUnscheduledPodsQueryOptions = (clusterId: string) =>
  queryOptions({
    queryKey: getUnscheduledPodsQueryKey(clusterId),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getUnscheduledPods({
        clusterId,
      });
      return data;
    },
    enabled: !!clusterId,
  });

export const useUnscheduledPodsQuery = (clusterId: string) => {
  return useQuery(getUnscheduledPodsQueryOptions(clusterId));
};
